import { jsx, jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useTranslation } from "@crehana/i18n";
import { LANGUAGES } from "@crehana/ts-types";
import { ChipGroup } from "../ChipGroup/chip-group.js";
import { Dropdown, DropdownContent, DropdownEmpty, DropdownSearchInput, DropdownValue } from "./Dropdown.js";
import { DropdownCheckboxList } from "./DropdownCheckboxList.js";
import { DropdownTextList } from "./DropdownTextList.js";
const i18n = {
    [LANGUAGES.ES]: {
        clearButton: 'Borrar todo',
        inputPlaceholder: 'Seleccione las opciones',
        noFoundPlaceholderTitle: 'No se han encontrado resultados',
        noFoundPlaceholderSubtitle: 'Prueba palabras clave más generales'
    },
    [LANGUAGES.PT]: {
        clearButton: 'Limpar',
        inputPlaceholder: 'Selecione as opções',
        noFoundPlaceholderTitle: 'Nenhum resultado encontrado',
        noFoundPlaceholderSubtitle: 'Tente palavras-chave mais gerais'
    },
    [LANGUAGES.EN]: {
        clearButton: 'Clear all',
        inputPlaceholder: 'Select options',
        noFoundPlaceholderTitle: 'No results found',
        noFoundPlaceholderSubtitle: 'Try more general keywords'
    }
};
const MAX_CHIPS_ROWS = 1;
const EXTRA_WIDTH_FROM_CLOSE = 28;
function DropdownWithChips({ items, placeholder: placeholderProp, loading, selected: selectedProp, onSelect: onSelectProp, labels, maxChipsRows = MAX_CHIPS_ROWS, extraWidthFromClose = EXTRA_WIDTH_FROM_CLOSE, forcedValue, searchInputPlaceholder, itemListVariant, disabled, open, onOpenChange }) {
    const { languageCode } = useTranslation();
    const locales = i18n[languageCode];
    const [_selectedItems, _setSelectedItems] = useState(selectedProp ?? []);
    const selected = selectedProp || _selectedItems;
    const onSelect = onSelectProp || _setSelectedItems;
    const placeholder = placeholderProp || locales.inputPlaceholder;
    const clearButtonLabel = labels?.clearButton || locales.clearButton;
    const noFoundPlaceholderTitle = labels?.noFoundPlaceholderTitle || locales.noFoundPlaceholderTitle;
    const noFoundPlaceholderSubtitle = labels?.noFoundPlaceholderSubtitle || locales.noFoundPlaceholderSubtitle;
    const itemListVariantJsx = {
        checkbox: /*#__PURE__*/ jsx(DropdownCheckboxList, {
            items: items,
            selected: selected,
            onSelect: (values)=>{
                onSelect(values);
            }
        }),
        text: /*#__PURE__*/ jsx(DropdownTextList, {
            items: items,
            selected: selected,
            onSelect: (values)=>{
                onSelect(values);
            },
            multiselect: true
        })
    }[itemListVariant];
    const onDelete = (value)=>{
        onSelect(selected.filter((el)=>el !== value));
    };
    const onClearAll = ()=>{
        onSelect([]);
    };
    return /*#__PURE__*/ jsxs("div", {
        children: [
            /*#__PURE__*/ jsxs(Dropdown, {
                open: open,
                onOpenChange: onOpenChange,
                children: [
                    /*#__PURE__*/ jsx(DropdownValue, {
                        size: "small",
                        placeholder: placeholder,
                        disabled: disabled || loading,
                        forcedValue: forcedValue || placeholder
                    }),
                    /*#__PURE__*/ jsxs(DropdownContent, {
                        removePortal: true,
                        children: [
                            /*#__PURE__*/ jsx(DropdownSearchInput, {
                                placeholder: searchInputPlaceholder || placeholder
                            }),
                            /*#__PURE__*/ jsx(DropdownEmpty, {
                                title: noFoundPlaceholderTitle,
                                subtitle: noFoundPlaceholderSubtitle
                            }),
                            itemListVariantJsx
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ jsx(ChipGroup, {
                items: items,
                selected: selected,
                onDelete: onDelete,
                onClearAll: onClearAll,
                maxChipsRows: maxChipsRows,
                extraWidthFromClose: extraWidthFromClose,
                clearButtonLabel: clearButtonLabel
            })
        ]
    });
}
export { DropdownWithChips };
